import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_right_2",
  "use": "icon-arrow_right_2-usage",
  "viewBox": "0 0 25.074 20.148",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25.074 20.148\" id=\"icon-arrow_right_2\"><defs><style>#icon-arrow_right_2 .a{fill:#8d8d8d;}</style></defs><path class=\"a\" d=\"M306.042,313.008l-10.074,10.074-1.567-1.567,8.507-8.507L294.4,304.5l1.567-1.567Zm13.432,0L309.4,323.082l-1.567-1.567,8.507-8.507-8.507-8.507,1.567-1.567Z\" transform=\"translate(-294.4 -302.934)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol